import Select from '@components/v2/form/Select/Select';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, MenuItem } from '@mui/material';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import {
  ExportImageModel,
  ExportImageModelSelectProps,
} from '../../types/catalogExportModal.types';
import { exportImageModelOptions } from '../../utils/catalogExportModal.utils';

const ExportImageModelSelect = ({
  exportImageModel,
  handleChangeImageModel,
}: ExportImageModelSelectProps) => {
  const { translate } = useTranslation();

  const renderSelectedLabel = (selected: unknown) => {
    const selectedOption = exportImageModelOptions.find((option) => option.value === selected);

    return translate(selectedOption?.label ?? LangEnum.GLOBAL_EXPORT_MODEL);
  };

  return (
    <Select
      required
      name="exportImageModel"
      label={translate(LangEnum.GLOBAL_EXPORT_MODEL)}
      value={exportImageModel}
      renderValue={renderSelectedLabel}
      onChange={(event) => handleChangeImageModel(event.target.value as ExportImageModel)}
    >
      {exportImageModelOptions.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          <Box>
            <Typography variant="body2">{translate(item.label)}</Typography>
            <Typography variant="caption" color="textSecondary">
              {translate(item.subtitle)}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default ExportImageModelSelect;
